// import React from "react";
// import { Link } from "react-router-dom"; // Import Link for client-side routing
// import "./Footer.css"; // Import styles

// function Footer() {
//   return (
//     <footer className="footer">
//       <div className="footer-container">
        
//         {/* About Us Section */}
//         <div className="footer-section">
//           <h3>About Us</h3>
//           <p>
//             Minerva Precision specializes in high-quality mould and die manufacturing, 
//             ensuring cutting-edge solutions for industries worldwide.
//           </p>
//         </div>

//         {/* Quick Links */}
//         <div className="footer-section">
//           <h3>Quick Links</h3>
//           <ul>
//             <li><Link to="/products">Infrastructure</Link></li>
//             <li><Link to="/client">Clients</Link></li>
//             <li><Link to="/services">Services</Link></li>
//             <li><Link to="/contact">Contact Us</Link></li>
//           </ul>
//         </div>

//         {/* Contact Information */}
//         <div className="footer-section">
//           <h3>Contact Info</h3>
//           <p>
//             Email: <a href="mailto:minervaprecision@gmail.com">minervaprecision@gmail.com</a>
//           </p>
//           <p>
//             Phone: <a href="Mob:+91 9865874056">+91 9865874056</a>
//           </p>
//           <p>Address: Plot No. 3, R.S No. 34/1-A, Annaimatha Nagar, Pothumbu(Post), Madurai, Tamil Nadu 625018.</p>
//         </div>

//         {/* Google Map Section */}
//         <div className="footer-section map">
//           <h3>Our Location</h3>
//           <iframe
//             title="Company Location"
//             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.086094942722!2d78.11977537499999!3d9.925200092902436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c58f0633f35f%3A0x465d1fc24b849cfb!2sMadurai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1709311234567!5m2!1sen!2sin"
//             width="100%"
//             height="200"
//             style={{ border: "0", borderRadius: "10px" }}
//             allowFullScreen=""
//             loading="lazy"
//           ></iframe>
//         </div>
//       </div>

//       {/* Footer Bottom */}
//       <div className="footer-bottom">
//         <p>&copy; {new Date().getFullYear()} Minerva Precision | All Rights Reserved</p>
//       </div>
//     </footer>
//   );
// }

// export default Footer;

import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const handleSubscribe = (e) => {
    e.preventDefault();
    const email = e.target.elements.email.value.trim();

    if (email) {
      alert("Thank you for subscribing to our newsletter!");
      e.target.reset(); // Clear the form
    } else {
      alert("Please enter a valid email address.");
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* About Us */}
        <div className="footer-section">
          <h3>About Us</h3>
          <p>
            Minerva Precision specializes in high-quality mould and die manufacturing,
            delivering cutting-edge solutions for industries globally.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/products">Infrastructure</Link></li>
            <li><Link to="/client">Clients</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>Email: <a href="mailto:minervaprecision@gmail.com">minervaprecision@gmail.com</a></p>
          <p>Phone: <a href="tel:+919865874056">+91 98658 74056</a></p>
          <p>Address: Plot No. 3, R.S No. 34/1-A, Annaimatha Nagar, Pothumbu(Post), Madurai, Tamil Nadu 625018.</p>
        </div>

        {/* Newsletter */}
        <div className="footer-section">
          <h3>Subscribe</h3>
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              name="email"
              placeholder="Your email"
              required
            />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Minerva Precision | All Rights Reserved</p>
      </div>
    </footer>
  );
}

export default Footer;